var exports = {
  "R": "x9245d464--2afb95--heading",
};

module.exports = exports;
